import { Component, EventEmitter, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BehaviorSubject, Observable, Subject, combineLatest, filter, from, map, merge, of, scan, startWith, switchMap, tap } from 'rxjs';
import { FavoritesServiceService } from '../services/favorites-service.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SubSink } from 'subsink';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lcms-favorites-list',
  templateUrl: './favorites-list.component.html',
  styleUrls: ['./favorites-list.component.scss'],
})
export class FavoritesListComponent {
  editMode: boolean[] = [];
  newTitles: string[] = [];
  newTitle = '';
  newUrls: string[] = [];
  newUrl = '';
  startPage = 0;
  paginationLimit = 5;
  constructor(protected activatedRoute: Router, private favoritesService: FavoritesServiceService, private translateService: TranslateService) {
  }

  currentUrl$: Observable<string> = this.activatedRoute.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.url),
    startWith(this.activatedRoute.url)
  );

  getFavorites$: Observable<any[]> = this.favoritesService.favoriteList$.pipe(
    map((listfav)=>{
    return   listfav.sort((a : any, b: any)=>{
        return a.position - b.position
      })
    })
  );

  isLoading$ = this.favoritesService.isLoadingAction$$;

  isFavoriteUrl$ = combineLatest([this.getFavorites$, this.currentUrl$]).pipe(
    map(([favoriteList, url]) => favoriteList.some((fav: any) => fav.url === url))
  );
  toggleEditMode(index: number, title?: string, url?: string): void {
    if (title) {
      this.newTitles[index] = title;
    }
    if (url) {
      this.newUrls[index] = url;
    }
    this.editMode[index] = !this.editMode[index];
  }
  openPlayerWindow(url: string, type: string): void {
    console.log(url, type);

    if (type !== 'ressource') {
      this.activatedRoute.navigateByUrl(url)
    } else {
      window.open(url, '_blank');
    }
  }
  saveFavorite(newTitle: string, index?: number, id?: string | number, url = ''): void {
    // If newTitle is empty after trimming, display an error and exit
    if (!newTitle) {
      const errorMessage = this.translateService.instant('AUTH.Required.FormFieldsRequired');
      Swal.fire({
        title: errorMessage,
        icon: 'error'
      });
      return;
    }
    const payload: any = {
      id: id ?? '',
      name: newTitle,
      icon: 'fa fa-',
      url: url
    }
    if (id) {
      this.favoritesService.updateAction$$.next(payload)
    } else {
      payload.url = this.activatedRoute.url ?? '';
      this.favoritesService.addAction$$.next(payload)
    }
    if (typeof index !== "undefined") {
      this.editMode[index] = false;
    }
  }


  drop(event: CdkDragDrop<any>, Favorites: any[]) {
    if (event.previousIndex !== event.currentIndex) {
      const payload = {
        target: {
          id: event.item.data.id,
          position: Favorites[event.currentIndex].position
        },
        source: {
          id: Favorites[event.currentIndex].id,
          position: Favorites[event.previousIndex].position
        }
      }
      this.favoritesService.changePositionAction$$.next(payload);
      moveItemInArray(Favorites, event.previousIndex, event.currentIndex);
    }
  }
  delete(item: any): void {
    this.favoritesService.deleteAction$$.next(item)
  }
  showMoreItems()
  {
    this.paginationLimit = Number(this.paginationLimit) + 5;
  }
  showLessItems()
  {
    this.paginationLimit = Number(this.paginationLimit) - 5;
  }
}
